import { useAppStore, type IAppStore } from '@/store';
import useChooserResponse from '@/hooks/useChooserResponse';
import CreateSkeleton from '../CreateSkeleton';
import CreateContent from '../CreateContent';

const selector = (store: IAppStore) => ({
  selectedPreset: store.selectedPreset,
  isPresetLoading: store.isPresetLoading,
});

/**
 * Thin layout root for the Create panel. Owns nothing but the skeleton vs
 * content decision; every other concern (preview, inputs, generate action)
 * is owned by the section that renders it.
 */
const Create = () => {
  const { selectedPreset, isPresetLoading } = useAppStore(selector);
  useChooserResponse();

  if (isPresetLoading || !selectedPreset) {
    return <CreateSkeleton />;
  }
  return <CreateContent />;
};

export default Create;
